import { EElevatorType } from '../../../../../../../packages/JsonQuery';
import { FC, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useFilterChangeCallback } from 'shared/hooks';
import { selectElevatorsFilter } from 'shared/selectors/advancedFilters';
import { AdvancedFilterRow, SingleSelectionAdvancedFilter } from 'shared/components/AdvancedFilter';

export const ElevatorsContainer: FC = () => {
  const { label, value, options } = useSelector(selectElevatorsFilter);

  const onChange = useFilterChangeCallback();

  const handleElevatorsChange = useCallback(
    (newValue: EElevatorType | null) => {
      onChange({ action: 'setElevatorType', arguments: [newValue] });
    },
    [onChange],
  );

  return (
    <AdvancedFilterRow label={label}>
      <SingleSelectionAdvancedFilter value={value} options={options} onFilterChange={handleElevatorsChange} />
    </AdvancedFilterRow>
  );
};
